import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import LoadingOutlined from '@ant-design/icons/LoadingOutlined';
import clsx from 'clsx';

import { OpButton } from 'new-components/DLS/OpButton/OpButton';

import { useMarketing } from './hooks/useMarketing';

import './Marketing.scss';

export const Marketing = () => {
  const { marketingData, isFetching } = useMarketing();

  const isError = !marketingData && !isFetching;

  return (
    <div
      data-testid="marketing-content-container"
      className={clsx('marketing-content', {
        'marketing-content__empty': isError,
        'marketing-content__filled': marketingData,
      })}
      style={{
        backgroundImage: marketingData
          ? `url("${marketingData?.backgroundImage}")`
          : undefined,
      }}
    >
      {!isError &&
        (isFetching ? (
          <div className="marketing-content__loader">
            <LoadingOutlined />
          </div>
        ) : (
          <>
            <div className="marketing-content__text">
              <h1 className="marketing-content__headline">
                {marketingData?.headline}
              </h1>
              <div className="marketing-content__body">
                {marketingData?.bodyContent &&
                  documentToReactComponents(marketingData.bodyContent)}
              </div>
              <OpButton
                type="primary"
                className="marketing-content__cta"
                onClick={() => {
                  window.open(marketingData?.buttonLink, '_blank');
                }}
              >
                {marketingData?.buttonText}
              </OpButton>
            </div>
            <div className="marketing-content__overlay" />
          </>
        ))}
    </div>
  );
};
